import script from "./RequirementView.vue?vue&type=script&setup=true&lang=js"
export * from "./RequirementView.vue?vue&type=script&setup=true&lang=js"

import "./RequirementView.vue?vue&type=style&index=0&id=afcf35e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afcf35e6"]])

export default __exports__